import { FixedDistributionAccount, maxSumAcrossPerspectives, } from '@debbie/common/dist/economy/fixed-distributions/index.js';
import { countedAmounts, getVoucherLabel, } from '@debbie/common/dist/economy/helpers/vouchers.js';
import { formatNumber } from '@debbie/common/dist/index.js';
import moment from 'moment';
import React from 'react';
import THEME from '../../../theme.js';
import { toPercent } from '../../../utils/index.js';
import AssociationIcon from '../../Icons/AssociationIcon.js';
import InfoIcon from '../../Icons/Info.js';
import PlusCircle from '../../Icons/PlusCircle.js';
import RotateCcw from '../../Icons/RotateCcw.js';
import Trash2 from '../../Icons/Trash2.js';
import XCircle from '../../Icons/XCircle.js';
import { Badge, Button, Errors, Money, Select } from '../../index.js';
import MoneyInput from '../../MoneyInput.js';
import { Actions, AdditionRow, Amount, AmountCol, ButtonRow, DateText, IconButton, Info, Label, Meta, Percentage, ReferenceId, RemainingRow, RightCol, Row, } from './CaseVoucherDistributionsStyles.js';
import { getEffectiveFds, getFdLimits, } from './CaseVoucherInfoDistributions.js';
import { fixedDistributionLabel } from './fixed-distribution-label.js';
const CaseVoucherDistributionsEdit = ({ voucher, caseVouchers, fixedDistributions, eligibleTargets, pending, isCredit, canSave, isSaving, lang, onAmountChange, onMarkForDeletion, onUndoDeletion, onAddDistribution, onUpdateAddition, onRemoveAddition, onSave, onCancel, onShowVoucherInfo, }) => {
    const effectiveFds = getEffectiveFds(fixedDistributions, pending, voucher, isCredit);
    const sourceFds = effectiveFds.filter((fd) => fd.fromCaseVoucherId === voucher.caseVoucherId);
    const editModeUnallocated = Math.abs(voucher.amount) - maxSumAcrossPerspectives(sourceFds);
    const targetErrorLabel = lang.economy.voucherInfoDistributionRemaining;
    return (React.createElement(React.Fragment, null,
        (voucher.distribution || [])
            .filter((dist) => dist.fixedDistributionId != null)
            .map((dist) => {
            const targetVoucher = caseVouchers.find((cv) => cv.caseVoucherId === dist.caseVoucherId);
            const voucherLabel = targetVoucher
                ? getVoucherLabel(targetVoucher, lang)
                : dist.caseVoucherId;
            const fd = fixedDistributions?.find((f) => f.id === dist.fixedDistributionId);
            if (!fd) {
                return null;
            }
            const isCreditorFd = fd.account === FixedDistributionAccount.Creditor;
            const isMirrorFd = fd.associationId != null &&
                fd.fromCaseVoucherId !== voucher.caseVoucherId;
            const isEditable = !isCreditorFd && !isMirrorFd;
            const isDeleted = pending.deletions.has(fd.id);
            const editedAmount = pending.edits.get(fd.id);
            const displayAmount = editedAmount !== undefined ? editedAmount : Math.abs(dist.amount);
            const { max, targetError } = isEditable && !isDeleted
                ? getFdLimits(effectiveFds, voucher, caseVouchers, editModeUnallocated, fd.id, dist.caseVoucherId, fd.account, displayAmount, targetErrorLabel)
                : { max: 0, targetError: null };
            return (React.createElement(Row, { key: dist.fixedDistributionId, $deleted: isDeleted },
                React.createElement(Info, null,
                    React.createElement(Label, null,
                        targetVoucher && (React.createElement(InfoIcon, { style: {
                                cursor: 'pointer',
                                userSelect: 'none',
                                flexShrink: 0,
                            }, onClick: () => onShowVoucherInfo(targetVoucher) })),
                        voucherLabel,
                        fd.associationId && (React.createElement(AssociationIcon, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.associateCases.associateCase })),
                        targetVoucher?.referenceId && (React.createElement(ReferenceId, { title: targetVoucher.referenceId },
                            "(",
                            targetVoucher.referenceId,
                            ")"))),
                    React.createElement(Meta, null,
                        targetVoucher && (React.createElement(DateText, null, moment(targetVoucher.date).format(THEME.DATE_FORMAT_SHORT))),
                        React.createElement(Badge, { theme: isCreditorFd ? THEME.COLOR_GREY : THEME.COLOR_ACCENT }, fixedDistributionLabel(lang, fd))),
                    targetError && React.createElement(Errors, { errors: [targetError] })),
                React.createElement(RightCol, null,
                    isEditable && !isDeleted ? (React.createElement(MoneyInput, { value: displayAmount, onChange: (v) => onAmountChange(fd.id, v), min: 0.01, max: max, placeholder: lang.economy.amount, style: { width: '120px' } })) : (React.createElement(AmountCol, null,
                        React.createElement(Amount, null,
                            React.createElement(Money, { amount: displayAmount })))),
                    isEditable && !fd.derived && (React.createElement(Actions, null, isDeleted ? (React.createElement(IconButton, { onClick: () => onUndoDeletion(fd.id), title: "Undo" },
                        React.createElement(RotateCcw, { size: "14px" }))) : (React.createElement(IconButton, { onClick: () => onMarkForDeletion(fd.id), title: lang.economy.voucherInfoDeleteFixedDistribution },
                        React.createElement(Trash2, { size: "14px" }))))))));
        }),
        pending.additions.map((addition) => {
            const { max: additionMax, targetError: additionTargetError } = addition.toCaseVoucherId
                ? getFdLimits(effectiveFds, voucher, caseVouchers, editModeUnallocated, addition.tempId, addition.toCaseVoucherId, FixedDistributionAccount.Both, addition.amount, targetErrorLabel)
                : {
                    max: Math.max(0, editModeUnallocated + addition.amount),
                    targetError: null,
                };
            return (React.createElement(AdditionRow, { key: addition.tempId },
                React.createElement("div", { style: { flex: 1, minWidth: 0 } },
                    React.createElement(Select, { value: addition.toCaseVoucherId, onChange: (e) => {
                            const selectedVoucherId = e.target.value;
                            if (!selectedVoucherId) {
                                onUpdateAddition(addition.tempId, {
                                    toCaseVoucherId: selectedVoucherId,
                                });
                                return;
                            }
                            const { max } = getFdLimits(effectiveFds, voucher, caseVouchers, editModeUnallocated, addition.tempId, selectedVoucherId, FixedDistributionAccount.Both, 0, targetErrorLabel);
                            onUpdateAddition(addition.tempId, {
                                toCaseVoucherId: selectedVoucherId,
                                amount: max > 0 ? max : addition.amount,
                            });
                        }, labelStyle: { marginBottom: 0, flex: 1, minWidth: 0 } },
                        React.createElement("option", { value: "" }, lang.economy.voucherInfoAllocatePaymentTarget),
                        eligibleTargets.map((cv) => (React.createElement("option", { key: cv.caseVoucherId, value: cv.caseVoucherId },
                            getVoucherLabel(cv, lang),
                            cv.referenceId ? ` (${cv.referenceId})` : '',
                            ' | ',
                            formatNumber(countedAmounts(cv).amount),
                            " ",
                            cv.currency)))),
                    additionTargetError && React.createElement(Errors, { errors: [additionTargetError] })),
                React.createElement(RightCol, null,
                    React.createElement(MoneyInput, { value: addition.amount, onChange: (v) => onUpdateAddition(addition.tempId, { amount: v }), min: 0.01, max: additionMax, placeholder: lang.economy.amount, style: { width: '120px' } }),
                    React.createElement(Actions, null,
                        React.createElement(IconButton, { onClick: () => onRemoveAddition(addition.tempId) },
                            React.createElement(XCircle, { size: "14px" }))))));
        }),
        React.createElement(RemainingRow, null,
            React.createElement(Label, null, lang.economy.voucherInfoDistributionUnallocated),
            React.createElement(AmountCol, null,
                React.createElement(Amount, null,
                    React.createElement(Money, { amount: Math.max(0, editModeUnallocated) })),
                React.createElement(Percentage, null,
                    toPercent(Math.max(0, editModeUnallocated) /
                        (Math.abs(voucher.amount) || 1), { precision: 2 }),
                    ' ',
                    "%"))),
        editModeUnallocated < 0 && (React.createElement(Errors, { errors: [lang.economy.voucherInfoDistributionRemaining] })),
        React.createElement(ButtonRow, null,
            React.createElement(IconButton, { onClick: onAddDistribution, title: lang.misc.add },
                React.createElement(PlusCircle, { size: "16px" })),
            React.createElement("div", { style: { flex: 1 } }),
            React.createElement(Button, { size: "mini", loading: isSaving, onClick: onSave, disabled: !canSave }, lang.misc.save),
            React.createElement(Button, { size: "mini", theme: "secondary", onClick: onCancel, disabled: isSaving }, lang.misc.cancel))));
};
export default CaseVoucherDistributionsEdit;
//# sourceMappingURL=CaseVoucherDistributionsEdit.js.map